import { lazy } from 'react';

// ----------------------------------------------------------------------

const HumanResourcesPage = lazy(() => import('../pages/HumanResources.page'));
const EmployeeDetailsPage = lazy(() => import('../pages/EmployeeDetails.page'));
const DeparturePage = lazy(() => import('../pages/Departure.page'));
const SalariesPage = lazy(() => import('../pages/Salaries.page'));
const EmployeesPage = lazy(() => import('../pages/Employees.page'));
const AddEmployeePage = lazy(() => import('../pages/AddEmployee.page'));
const EditEmployeePage = lazy(() => import('../pages/EditEmployee.page'));
const EmployeeAttendancePage = lazy(() => import('../pages/EmployeeAttendance.page'));
const ShiftsPage = lazy(() => import('../pages/Shifts.page'));
const AddShiftPage = lazy(() => import('../pages/AddShift.page'));
const EditShiftPage = lazy(() => import('../pages/EditShift.page'));
const ContractsPage = lazy(() => import('../pages/Contracts.page'));
const AddContractPage = lazy(() => import('../pages/AddContract.page'));
const ContractDetailsPage = lazy(() => import('../pages/ContractDetails.page'));
const SalariesDetails = lazy(() => import('../pages/SalariesDetails.page'));
const AddAllowancePage = lazy(() => import('../pages/AddAllowance.page'));
const EmployeeSalaryDetails = lazy(() => import('../pages/EmployeeSalaryDetails'));
const DepartmentsPage = lazy(() => import('../pages/departments/Departments.page'));
const EditDepartmentPage = lazy(() => import('../pages/departments/EditDepartment.page'));
const AddDepartmentPage = lazy(() => import('../pages/departments/AddDepartment.page'));
const DepartmentManagersPage = lazy(() => import('../pages/managers/DepartmentManagers.page'));
const BranchManagersPage = lazy(() => import('../pages/managers/BranchManagers.page'));
const EmployeeReviewsPage = lazy(() => import('../pages/EmployeeReviews.page'));
const LoanRequestsPage = lazy(() => import('../pages/LoanRequests.page'));
// ----------------------------------------------------------------------

const HumanResourcesRoutes = [
    {
        path: '/human-resources',
        children: [
            { element: <HumanResourcesPage />, layout: 'default', isAuthReq: true, index: true },
            { path: 'employees', element: <EmployeesPage />, layout: 'default', isAuthReq: true },
            { path: 'add-employee', element: <AddEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id', element: <EmployeeDetailsPage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id/edit', element: <EditEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'departure', element: <DeparturePage />, layout: 'default', isAuthReq: true },
           
            {
                path: 'employee/:id/attendance',
                element: <EmployeeAttendancePage />,
                layout: 'default',
                isAuthReq: true,
            },
            { path: 'shifts', element: <ShiftsPage />, layout: 'default', isAuthReq: true },
            { path: 'add-shift', element: <AddShiftPage />, layout: 'default', isAuthReq: true },
            { path: 'shifts/:id/edit', element: <EditShiftPage />, layout: 'default', isAuthReq: true },
            { path: 'contract-management', element: <ContractsPage />, layout: 'default', isAuthReq: true },
            {
                path: 'contract-management/add-contract',
                element: <AddContractPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'contract-management/:id',
                element: <ContractDetailsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            { path: 'salaries-details', element: <SalariesDetails />, layout: 'default', isAuthReq: true },
            { path: 'salaries-details/:id', element: <EmployeeSalaryDetails />, layout: 'default', isAuthReq: true },
            {
                path: 'salaries-details/add-allowance',
                element: <AddAllowancePage />,
                layout: 'default',
                isAuthReq: true,
            },
            { path: 'departments', element: <DepartmentsPage />, layout: 'default', isAuthReq: true },
            { path: 'add-department', element: <AddDepartmentPage />, layout: 'default', isAuthReq: true },
            // { path: 'department/:id', element: <DepartmentDetailsPage />, layout: 'default', isAuthReq: true },
            { path: 'department/:id/edit', element: <EditDepartmentPage />, layout: 'default', isAuthReq: true },
            { path: 'department-managers', element: <DepartmentManagersPage />, layout: 'default', isAuthReq: true },
            { path: 'branch-managers', element: <BranchManagersPage />, layout: 'default', isAuthReq: true },
            { path: 'employees-reviews', element: <EmployeeReviewsPage />, layout: 'default', isAuthReq: true },
            { path: 'personal-loans', element: <LoanRequestsPage />, layout: 'default', isAuthReq: true },
        ],
    },
    {
        path: '/finances',
        children: [
            { path: 'salaries', element: <SalariesPage />, layout: 'default', isAuthReq: true },
            { path: 'salaries-details/:id', element: <EmployeeSalaryDetails />, layout: 'default', isAuthReq: true },
            { path: 'personal-loans', element: <LoanRequestsPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { HumanResourcesRoutes };
